angular
	.module 'App.Repository'
	.factory 'ProductVariantSkuRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ProductVariantSkuRepository extends BaseRepository
				@resource = '/product_variant_skus'
				@isRestricted = true

			return new ProductVariantSkuRepository
	]
